import { AxiosResponse } from 'axios';
import { UserResponse } from 'Models/User';
import { getAxiosInstance } from 'Utils/Http/ApiManager';
import { ApiUrl, getApiUrl } from 'Utils/Http/ApiUrls';

export interface PatchUserPasswordResponse {
	user: UserResponse;
}

const patchUserPassword = async (
	token: string | null,
	userId: number,
	password: string
): Promise<AxiosResponse<PatchUserPasswordResponse>> => {
	const url = getApiUrl(ApiUrl.UsersPassword).replace(':userId', userId.toString());
	const axios = getAxiosInstance(token);
	return axios.patch<PatchUserPasswordResponse>(url, { password });
};

export default patchUserPassword;
